import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary';
  className?: string;
  scrollTo?: string;
}
export function CTAButton({
  children,
  href = 'https://pay.hotmart.com/W59373587R?off=1b7maynq',
  variant = 'primary',
  className = '',
  scrollTo
}: CTAButtonProps) {
  const isPrimary = variant === 'primary';
  const baseStyles = 'inline-flex items-center justify-center text-center font-bold rounded-full transition-all duration-300 ease-out px-8 py-4 text-sm md:text-base w-full sm:w-auto cursor-pointer';
  const primaryStyles = 'bg-rose text-white shadow-soft hover:bg-rose-light hover:-translate-y-1 hover:shadow-glow';
  const secondaryStyles = 'bg-transparent text-rose border-2 border-rose hover:bg-rose hover:text-white';
  const handleClick = (e: React.MouseEvent) => {
    if (scrollTo) {
      e.preventDefault();
      // Track as Lead when scrolling to pricing
      trackEvent('Lead', {
        content_name: 'scroll_to_pricing'
      });
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    } else {
      // Track as InitiateCheckout when clicking purchase link
      trackEvent('InitiateCheckout', {
        content_name: 'Nails Artist Expert',
        currency: 'USD',
        value: 29.0
      });
    }
  };
  return <motion.a href={scrollTo ? `#${scrollTo}` : href} target={scrollTo ? undefined : '_blank'} rel={scrollTo ? undefined : 'noopener noreferrer'} onClick={handleClick} className={`${baseStyles} ${isPrimary ? primaryStyles : secondaryStyles} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-255">
      {children}
    </motion.a>;
}